import { OutliersBenchmarkType } from 'widgets/outliers/store/config/OutliersConfigState';
import Order, { OrderColumn } from 'communication/types/order/Order';
import { arrivalPriceBenchmarkStrategy } from 'widgets/outliers/data/benchmarksStrategies/arrivalPriceBenchmark';
import { adjustedArrivalPriceBenchmarkStrategy } from 'widgets/outliers/data/benchmarksStrategies/adjustedArrivalPriceBenchmarkStrategy';

export interface OutliersBenchmarkData {
    benchmarkPrice: number;
}

export interface OutliersBenchmarkStrategy {
    mapOrder: (
        order: Order,
        exchangeRate: number
    ) => OutliersBenchmarkData | undefined;
    getRequiredColumns: () => OrderColumn[];
}

export const benchmarkStrategies: Record<
    OutliersBenchmarkType,
    OutliersBenchmarkStrategy
> = {
    arrivalPrice: arrivalPriceBenchmarkStrategy,
    adjustedArrivalPrice: adjustedArrivalPriceBenchmarkStrategy,
};
